module.exports = __webpack_public_path__ + "img/tabicon_1.20607dd7.png";